module.exports = __webpack_public_path__ + "static/img/app-logo.557b4d38.png";